<script>

	import Header from './Header.svelte';
	import TokenDetail from './TokenDetail.svelte';
	import HomePage from './HomePage.svelte';

	let webUrl = window.location.href;
	let tokenId = webUrl.split('/')[3];

</script>

<style>
	/* ================ GLOBAL APP STYLES ==================== */

	/* :global(body) {
		font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif, sans;
	} */

	:global(*) { box-sizing:border-box; }

	:global([hidden]) { display:none !important; }

	:global(a) {
		color: #FFF;
		font-weight:500;
		text-decoration:none;
	}

	/* TODO */
	:global(a:hover) {
		text-decoration:underline;
	}

	/* TODO */
	:global(a:visited) {
		color: rgb(0,80,160);
	}

	:global(ul) {
		padding-inline-start: 1em;
	}


	:global(svg.ico) {
		width:24px;
		height:24px;
		background:transparent;
	}


	:global(button) {
		background:#FFF;
		color: #444;
		text-transform:capitalize;

		height:44px;
		min-width:6em;
		margin:0 0.29em;
		padding:0.6em 0.57em;
		-webkit-font-smoothing:antialiased;
		-webkit-tap-highlight-color:transparent;
		outline:0;
		outline:none;
		-webkit-user-select:none;
		user-select:none;
		cursor:pointer;
		z-index:0;
		appearance:none;

		font-weight:700;
		outline-width:0;
		border:0;
		border-radius:22px;
		overflow:hidden;
		text-align:center;

		transition:background 200ms ease-in-out, box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);

		display:inline-flex;
		flex-direction:row;
		justify-content:center;
		align-items:center;
		flex-grow:0;
	}

	:global(button[small]) {
		height:34px;
		min-width:5em;
		border-radius:17px;
		padding:0.5em 0.47em;
	}

	:global(button[pill]) {
		height:28px;
		min-width:4em;
		border-radius:14px;
		padding:2px 6px;
		font-weight:700;
		color:#444;
	}

	:global(button[pill][primary]) {
		background:#ff9e22;
		color:#444;
	}

	:global(button[raised]:not([disabled])) {
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
	}

	:global(.paper-button[raised]:focus:not([disabled]):not(:active)) {
		/* font-weight:700; */
		box-shadow:0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.4);
		/* transform: scale(1.01); */
	}

	:global(button:active) {
		transform: scale(0.99);
		transition-duration:50ms;
		box-shadow:none !important;
	}

	:global(button[disabled]) {
		opacity:0.9;
		pointer-events: none;
	}


	/* -------------- SPINNER ---------------- */

	:global(.spinner) {
		height: 44px;
		width: 44px;
		color: #FFF;
		position: relative;
		display: inline-block;
		border: 5px solid;
		border-radius: 50%;
		border-top-color: transparent;
		animation: rotate 1s linear infinite;
	}

	:global(.spinner[pill]) {
		height: 22px;
		width: 22px;
		color: #ff9e22;
		border-width: 3px;
		margin-right: 3px;
	}
	:global(.spinner[pill][primary]) {
		color:white;
	}

	@keyframes -global-rotate {
		0%   { transform: rotate(0);      }
		100% { transform: rotate(360deg); }
	}


</style>

<Header />		<!-- tokenId={tokenId} -->

{#if tokenId}
	<TokenDetail tokenId={tokenId} />
{:else}
	<HomePage />
{/if}
